// React
import React from 'react';

// Packages

// Utilities
import { getYears } from 'utilities';
import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsCompanyDetails } from 'components/_cardContents/resultsCompany/resultsCompany';

const Name = CONSTANTS.RESULTS.COMPANY;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Company_Type__c',
        fieldName: 'Company_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Company_Type__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsCompanyDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const {
            Company_Type__c,
            Company_Name__c,
            Company_Registration__c,
            Year__c,
        } = formData;

        // Data for sf
        return {
            Company_Type__c,
            Company_Name__c,
            Company_Registration__c,
            Year__c: Year__c?.length > 0 ? Year__c : null,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'TextLookup',
                name: 'Company_Registration__c',
                object: object.config(
                    'Initiative_Result__c.Company_Registration__c'
                ),
                maxLength: 200,
                config: {
                    type: 'vat',
                    async onAccept(lookup) {
                        lookup?.name &&
                            props.form.setValue(
                                'Company_Name__c',
                                lookup?.name
                            );
                        lookup?.registrationDate &&
                            props.form.setValue(
                                'Year__c',
                                `${lookup.registrationDate.substring(
                                    0,
                                    4
                                )}-01-01`
                            );
                        props.form.trigger();
                    },
                },
            },
            {
                type: 'Text',
                name: 'Company_Name__c',
                object: object.config('Initiative_Result__c.Company_Name__c'),
                maxLength: 200,
            },
            {
                type: 'Select',
                name: 'Year__c',
                object: object.config('Initiative_Result__c.Year__c___Company'),
                options: getYears(),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '___Company',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Company_Type__c,

        Company_Name__c,
        Company_Registration__c,
        Year__c,
    } = utilities.results.get(id);

    // Choice
    form.setValue('Company_Type__c', Company_Type__c);

    form.setValue('Company_Name__c', Company_Name__c);
    form.setValue('Company_Registration__c', Company_Registration__c);
    form.setValue('Year__c', Year__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
